module.exports = __webpack_public_path__ + "static/media/homepage-admin-reports.367bd150.webm";